export default "__VITE_ASSET__ctt5fU2G__"